'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _constants = require('../../../rules/src/constants');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var isFocused = function isFocused(obj) {
  var highlightIndex = R.propOr(-1, 'highlightIndex', obj);
  var baselineIndex = R.propOr(-1, 'baselineIndex', obj);
  return highlightIndex > -1 || baselineIndex > -1;
};
var sampleFilterSeries = function sampleFilterSeries(series) {
  return R.map(function (serie) {
    var _datapoints = R.filter(isFocused, serie.datapoints);
    return (0, _extends3.default)({}, serie, {
      datapoints: _datapoints
    });
  }, series);
};
var lineFilterSeries = R.filter(isFocused);
exports.default = function (series, type, options) {
  var responsiveFocusFilter = R.pathOr(true, ['serie', 'responsiveFocusFilter'], options);
  if (!responsiveFocusFilter) {
    return series;
  }
  var height = R.path(['base', 'height'], options);
  var width = R.path(['base', 'width'], options);
  var minWidth = R.path(['base', 'minDisplayWidth'], options);
  var minHeight = R.path(['base', 'minDisplayHeight'], options);
  var filtered = void 0;
  if (type === _constants.H_SYMBOL) {
    if (height < minHeight) {
      filtered = sampleFilterSeries(series);
      return R.isEmpty(filtered[0].datapoints) ? series : filtered;
    }
  } else if (type === _constants.TIMELINE) {
    if (height < minHeight) {
      filtered = lineFilterSeries(series);
      return R.isEmpty(filtered) ? series : filtered;
    }
  } else if (type === _constants.V_SYMBOL) {
    if (width < minWidth) {
      filtered = sampleFilterSeries(series);
      return R.isEmpty(filtered[0].datapoints) ? series : filtered;
    }
  }
  return series;
};